import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden", "label", "option"]

  connect() {
    this.updateLabel()
  }

  select(event) {
    event.preventDefault()
    
    const value = event.currentTarget.dataset.value
    const label = event.currentTarget.dataset.label
    
    this.hiddenTarget.value = value
    this.labelTarget.textContent = label
    
    // Update visual active state
    this.optionTargets.forEach(opt => {
      if (opt.dataset.value === value) {
        opt.classList.add("bg-surface-50", "font-medium")
      } else {
        opt.classList.remove("bg-surface-50", "font-medium")
      }
    })

    // Dispatch change event to trigger auto-submit or generic observers
    this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }))
    
    // Dispatch a custom event to notify dropdown controller to close
    this.dispatch("select")
  }

  updateLabel() {
    const value = this.hiddenTarget.value
    const activeOption = this.optionTargets.find(opt => opt.dataset.value === value)
    
    if (activeOption) {
      this.labelTarget.textContent = activeOption.dataset.label
    }
  }
}
